import { useActiveContactsStore } from '@/stores/active-contacts.store';

/**
 * Green dot indicator shown on contacts that have a live session in progress
 * (voice call or text conversation with the AI agent).
 *
 * Position this absolutely inside a relative-positioned avatar container.
 * The dot appears at the bottom-right of the avatar, Messenger-style.
 */
export const ActiveIndicator = ({ contactId }: { contactId: string }) => {
  const isActive = useActiveContactsStore((s) => s.activeIds.has(contactId));
  if (!isActive) return null;

  return (
    <span
      className="animate-active-pulse absolute -right-0.5 -bottom-0.5 block h-2.5 w-2.5 rounded-full bg-[#22c55e] ring-2 ring-white dark:ring-[#111b21]"
      aria-label="Active session"
    />
  );
};
